import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import classes from './menu-link.module.scss';

type Props = {
	label: string;
	image: string;
	link?: string;
	isLast: boolean;
};
export const MenuLink = memo((props: Props) => {
	const { label, image, link, isLast } = props;

	return (
		<div className={`${classes.menuLink} ${isLast ? '' : classes.menuLinkMargin}`}>
			{link ? (
				<Link to={link}>
					<img className={classes.image} src={`${process.env.PUBLIC_URL}/images/${image}`} alt={''} />
				</Link>
			) : (
				<img className={classes.image} src={`${process.env.PUBLIC_URL}/images/${image}`} alt={''} />
			)}
			<div aria-hidden="true">
				<b>{label}</b>
			</div>
		</div>
	);
});
